import { Region } from '../../../model/region.model';
import { PartyServiceStatusTypes } from './party-service-status-types.model';
import { Grade } from 'src/app/model/school.model';
import { PartyRoleTypes } from 'src/app/component/party/model/party-role-types.model';
import { ServiceCategories } from './service-categories.model';
import { SsdpComponents } from './ssdp-components.model';
import { MeasurableProgramObjectives } from './measurable-program-objectives.model';
import { ServiceHours } from './service-hours.model';
import { FederalCodes } from './federal-codes.model';
import { PartyServiceTypes } from './party-service-types.model';
import { EnrollmentPeriods } from '../../common-components/child-services/model/enrollment-periods.model';
import { ServiceHourRanges } from './service-hour-ranges.model';

export class PartyServices {
    ID?: number;
    SERVICE_NAME?: string;
    DESCRIPTION?: string;
    SERVICE_CODE?: number;
    REGIONS_ID?: number;
    REGION?: Region;
    PARENT_SERVICE_TYPES_ID?: number;
    PARENT_SERVICE_TYPES?: PartyServiceTypes;
    CHILD_SERVICE_TYPES_ID?: number;
    CHILD_SERVICE_TYPES?: PartyServiceTypes;
    SERVICE_CATEGORIES_ID?: number;
    SERVICE_CATEGORIES?: ServiceCategories;
    PARTY_SERVICE_STATUS_TYPES_ID?: number;
    PARTY_SERVICE_STATUS_TYPES?: PartyServiceStatusTypes;
    SERVICE_HOURS_ID?: number;
    SERVICE_HOURS?: ServiceHours;
    FEDERAL_CODES_ID?: number;
    FEDERAL_CODES?: FederalCodes;
    MEASURABLE_PROGRAM_OBJECTIVES_ID?: number;
    MEASURABLE_PROGRAM_OBJECTIVES?: MeasurableProgramObjectives;
    SSDP_COMPONENTS?: SsdpComponents[];
    SERVICE_PROVIDER_PARTY_ROLE_TYPES_ID?: number;
    SERVICE_PROVIDER?: PartyRoleTypes;
    GRADES?: Grade[];
    GRADES_FLAT?: string;
    ENROLLMENT_PERIODS: EnrollmentPeriods[];

    SERVICE_HOUR_RANGE: ServiceHourRanges;

    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
}
